import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ViewTeacherProfile = () => {
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 
  useEffect(() => {
    const fetchTeacher = async () => {
      try {
        const teacherData = JSON.parse(localStorage.getItem("teacher"));
const teacherId = teacherData?.id;
         const sessionId = localStorage.getItem("currentSessionId");
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${teacherId}`,
           { params: { sessionId } }
        );
        setTeacher(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    fetchTeacher();
  }, []);

  if (loading) return <div className="ml-64 p-6">Loading...</div>;
  if (error) return <div className="ml-64 p-6 text-red-500">Error: {error}</div>;

  return (
    <div className="ml-34 p-6 bg-gray-50 min-h-screen">
      {/* Card container */}
      <div className="container mx-auto bg-white shadow-lg rounded-lg p-6">
        <h1 className="text-3xl font-bold mb-6 text-center">Teacher Profile</h1>
        <hr />
        <br />
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Profile Image */}
          {teacher.profileImage && (
            <div className="flex justify-center md:row-span-3">
              <img
                src={teacher.profileImage}
                alt={`${teacher.firstName} ${teacher.lastName}`}
                className="rounded-lg shadow-lg w-64 h-64 object-cover"
              />
            </div>
          )}
          {/* Info Fields */}
          {teacher.firstName && (
            <InfoCard label="Name" value={`${teacher.firstName} ${teacher.lastName}`} />
          )}
          {teacher.phoneNo && <InfoCard label="Phone Number" value={teacher.phoneNo} />}
          {teacher.phoneNo2 && (
            <InfoCard label="Alternate Phone Number" value={teacher.phoneNo2} />
          )}
          {teacher.email && <InfoCard label="Email" value={teacher.email} />}
          {teacher.gender && <InfoCard label="Gender" value={teacher.gender} />}
          {teacher.dateOfBirth && (
            <InfoCard
              label="Date of Birth"
              value={new Date(teacher.dateOfBirth).toLocaleDateString()}
            />
          )}
          {teacher.age && <InfoCard label="Age" value={teacher.age} />}
          {teacher.state && <InfoCard label="State" value={teacher.state} />}
          {teacher.city && <InfoCard label="City" value={teacher.city} />}
          {teacher.address && <InfoCard label="Address" value={teacher.address} />}
          {teacher.category && <InfoCard label="Category" value={teacher.category} />}
          {teacher.financial && <InfoCard label="Financial Status" value={teacher.financial} />}
          {teacher.classYouTeach && (
            <InfoCard
              label="Classes You Teach"
              value={teacher.classYouTeach.join(', ')}
            />
          )}
          {teacher.subjectYouTeach && (
            <InfoCard
              label="Subjects You Teach"
              value={teacher.subjectYouTeach.join(', ')}
            />
          )}
          {teacher.qualification && <InfoCard label="Qualification" value={teacher.qualification} />}
          {teacher.experiencePeriod && (
            <InfoCard label="Experience Period" value={teacher.experiencePeriod} />
          )}
          {teacher.organization && <InfoCard label="Organization" value={teacher.organization} />}
          {teacher.designation && <InfoCard label="Designation" value={teacher.designation} />}
          {teacher.personalAchievements && (
            <InfoCard
              label="Personal Achievements"
              value={teacher.personalAchievements}
            />
          )}
          {teacher.classIncharge && <InfoCard label="Class Incharge" value={teacher.classIncharge} />}

          {/* Documents */}
          {teacher.tenthDmc && teacher.tenthDmc !== 'null' && (
            <DocCard label="10th DMC" url={teacher.tenthDmc} />
          )}
          {teacher.plusTwoDmc && teacher.plusTwoDmc !== 'null' && (
            <DocCard label="Plus Two DMC" url={teacher.plusTwoDmc} />
          )}
          {teacher.graduation && teacher.graduation !== 'null' && (
            <DocCard label="Graduation" url={teacher.graduation} />
          )}
          {teacher.masters && teacher.masters !== 'null' && (
            <DocCard label="Masters" url={teacher.masters} />
          )}
          {teacher.diploma && teacher.diploma !== 'null' && (
            <DocCard label="Diploma" url={teacher.diploma} />
          )}
        </div>
      </div>
    </div>
  );
};

// Reusable info card
const InfoCard = ({ label, value }) => (
  <div className="bg-gray-100 p-4 rounded-lg shadow-md">
    <strong className="block text-gray-700">{label}:</strong>
    <div className="text-gray-900">{value}</div>
  </div>
);

// Reusable document card--it will basically used to view the doc of teacher
const DocCard = ({ label, url }) => (
  <div className="bg-gray-100 p-4 rounded-lg shadow-md flex justify-between items-center">
    <span className="font-medium">{label}:</span>
    <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
      View Document
    </a>
  </div>
);

export default ViewTeacherProfile;
